import axios from "axios";
import { apiUrl } from "../config";
import authenticationStore from "../store/authenticationStore";

export const RoleRequest = {
    getRoles: () =>
        axios({
            method: "get",
            url: `${apiUrl}/api/v1/roles`,
            headers: {
                Authorization: `Bearer ${
                    JSON.parse(authenticationStore.appToken).access_token
                }`,
                "Content-Type": "application/json",
            },
        }),
};
